module.exports = new __parcel__URL__("camp-fire-background.f01785f2.jpg").toString();